<template>
  <LegalSiteArticle :page="aboutPage" nav-page="about" />
</template>

<script>
import LegalSiteArticle from '@/components/LegalSiteArticle.vue'
import { aboutPage } from '@/data/sitePages'

export default {
  components: { LegalSiteArticle },
  data() {
    return { aboutPage }
  },
}
</script>
